export default "__VITE_ASSET__DqSkl$Po__"